@if (newUser()) {
  {{ newUser() }} hat die Bearbeitung des Eingangs übernommen.
} @else {
  Der Eingang ist dir nicht mehr zugewiesen. Die hier erfassten Daten werden verworfen.
}
